import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import UploadFileModal from "./UploadFileModal";
import { useAuth } from "../../../firebase/AuthProvider";
import {
	FileViewData,
	GetEmployeeFilesRequest,
	GetEmployeFilesResponse,
} from "../../../interfaces/Employee/Employee";
import {
	GetEmployeeFileAsync,
	GetEmployeeFileDownloadByIdAsync,
} from "../../../services/EmployeeService/EmployeeService";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";
import { useNavigate } from "react-router-dom";
import { UserFile } from "../../../interfaces/userDrive/userFile";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TABLENAMES } from "../../../Data/SD";
import tableeyeopenicon from "../../../assets/images/tableeyeopenicon.svg";

const EmployeeFiles: React.FC = () => {
	const { currentUser } = useAuth();
	const [showUploadFileModal, setShowUploadFileModal] =
		useState<boolean>(false);
	const [authToken, setAuthToken] = useState<string>("");
	const [filesData, setFilesData] = useState<GetEmployeFilesResponse[]>([]);
	const [loading, setLoading] = useState<boolean>(false);
	const navigat = useNavigate();
	 const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

	useEffect(() => {
		if (!currentUser) return;
		currentUser.getIdToken().then((token) => {
			setAuthToken(token);
			GetEmployeeFile(token);
		});
	}, []);

	const GetEmployeeFile = async (token: string) => {
		try {
            if(!currentUser) return;
			setLoading(true);
            const payload :GetEmployeeFilesRequest = {
                userId: currentUser?.uid,
                pageNumber: 1,
                pageSize: 100
            }
			const empfileRes = await GetEmployeeFileAsync(token, payload);
			if (empfileRes.success) {
				setFilesData(empfileRes.data);
			} else {
				toast.error(
					empfileRes.message || "Failed to fetch employee files."
				);
			}
		} catch (error: any) {
			toast.error(
				error.message ||
					"An error occurred while fetching employee files."
			);
		} finally {
			setLoading(false);
		}
	};

	const NaviagateToViewFile = async (fileData: GetEmployeFilesResponse) => {
				navigat(`/view/file/${fileData.id}/${TABLENAMES.EMPLOYEE_FILE}`);

	};

	return (
		<>
			{loading && <Loader />}
			<div className="common_card ">
				<div className="top top_bar_flx">
					<div className="top_bar_tittle ">
						<h2>Employee Files</h2>
					</div>
					<Button variant="primary" className="btn_sm" onClick={() => {
						setShowUploadFileModal(true);
						handleShow();
					}} >Add File</Button>	
				</div>
				<Table responsive className="common_table">
					<thead>
						<tr>
							<th>File Name</th>
							<th>File Type</th>
							<th>Uploaded Date</th>
							<th className="action_th">Action</th>
						</tr>
					</thead>

					<tbody>
						{filesData.map((file, index) => (
							<tr key={index}>
								<td>
									{file.fileName}
								</td>
								<td>
									{file.documentCategoryName}
								</td>
								<td>
									{moment
										.utc(file.dateAdded)
										.local()
										.format("DD/MM/YYYY")}
								</td>
								<td className="action_btn">
									<button onClick={() => {NaviagateToViewFile(file);}}>
										<img src={tableeyeopenicon} alt="tableeyeopenicon" />
									</button>
								</td>
							</tr>
						))}
					</tbody>
				</Table>
				{showUploadFileModal && (
					<UploadFileModal
						setShowUploadFileModal={setShowUploadFileModal}
						authToken={authToken}
						GetEmployeeFile={GetEmployeeFile}
						handleClose={handleClose}
						handleShow={handleShow}
						show = {show}
					/>
				)}
	

			</div>
		</>
	);
};

export default EmployeeFiles;
